import { render, staticRenderFns } from "./CreateNewFolder.vue?vue&type=template&id=cc4e6ee0&"
import script from "./CreateNewFolder.vue?vue&type=script&lang=js&"
export * from "./CreateNewFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports